// extracted by mini-css-extract-plugin
export default {"container__bg":"MyPoints_container__bg__9j0dL"};